import axios from 'axios';
import { getToken, logout, isTokenExpired } from './authService';
import { API_BASE_URL } from 'src/apiConfig';

/* SERVIS ZA AUTH API */

// Kreiranje Axios instance
const api = axios.create({
  baseURL: API_BASE_URL
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (!token || isTokenExpired(token)) {
      logout();
      window.location.href = '/login';
      return Promise.reject(new Error('Token is expired or not available'));
    }

    // Ako token nije istekao, dodaj ga u header
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// // Response interceptor (ostavi ga kao što jeste za detekciju dodatnih grešaka)
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (
//       error.response &&
//       (error.response.status === 401 || error.response.status === 403)
//     ) {
//       // Token je verovatno istekao ili nije validan
//       logout(); // Funkcija koja briše token i korisničke podatke iz localStorage ili state-a
//       window.location.href = '/login'; // Preusmeri korisnika na login stranicu
//     }
//     return Promise.reject(error);
//   }
// );

export default api;
